export const experiments = {
  alternativeCopyDonationForm: 'CXQttyCJQ76zQ-XD3xBxxg'
};

export const experimentIds = Object.values(experiments);

export const isActiveExperiment = (experimentId: string) => {
  return experimentIds.some((id) => id === experimentId);
};
